export default "__VITE_ASSET__CVclJodu__"